import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';
// import { ROUTE_PATH } from '..';
import './styles.scss';
import { ROUTE_PATH } from 'routes';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from 'components/Buttons/Button';

const NotFound = ({ previousPath = null }) => {
  const literals = useSelector(state => state.i18n.literals.notFound);
  const isEmbed = window?.location?.pathname?.startsWith('/embed/');

  useEffect(() => {
    const isDirectLoad = !previousPath || previousPath === window.location.pathname;
    Sentry.withScope((scope) => {
      scope.setFingerprint(['404']);
      scope.setContext('404', {
        path: window.location.pathname + window.location.search,
        from: isDirectLoad ? '(entrada directa o recarga)' : previousPath,
        referrer: document.referrer || '(ninguno)',
      });
      Sentry.captureMessage('404 - Página no encontrada', 'warning');
    });
  }, [previousPath]);

  return (
    <div className='NotFound'>
      <div>
        <h1>404</h1>
        <div className='content'>
          <h2>{literals.title}</h2>
        </div>
        { !isEmbed && (
          <p>
            <Link to={ROUTE_PATH.BASEROUTE}>
              <Button text={literals.goBack} />
            </Link>
          </p>
        )}
      </div>
    </div>
  );
};

NotFound.propTypes = {
  previousPath: PropTypes.string,
};

NotFound.defaultProps = {
  previousPath: null,
};

export default NotFound;
